/**
 * @description: 账单查看
 * @author: hwx
 */
<template>
	<div class="actreport-manage-wrap">
		<ul class="list-tit" v-show="showTit">
			<li class="col-md-3"><span class="col-md-10" @click="titClk(1)">日营业明细报表</span></li>
			<li class="col-md-3"><span class="col-md-10" @click="titClk(2)">日营业汇总报表</span></li>
		</ul>
		<div class="list-con">
			<!-- 日营业明细报表 -->
			<div class="ym-list" v-show="showList1">
				<div class="row">
					<button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backFun">返回</button>
				</div>
				<h1>日营业明细报表</h1>
				<div class="row">
					<label class="col-md-1 list-label-2">日期:</label>
					<div class="col-md-2">
						<div ref="ym_date">
							<input type="text" class="form-control laydate-icon" v-model="ym_time">
						</div>
					</div>
					<label class="col-md-1 list-label-3">门店:</label>
					<div class="col-md-2 ct-col">
						<select class="form-control" ref="ym_shop"></select>
					</div>
					<label class="col-md-1 list-label-2">总计:</label>
					<div class="list-total">{{ym_amount}}</div>
					<div class="pull-right">
						<button type="button" class="btn btn-flat btn-small btn-orange" @click="ymQuery">查询</button>
						<button type="button" class="btn btn-flat btn-small btn-orange" @click="ymExportSet">导出</button>
					</div>
				</div>
				<div class="table-responsive">
					<table class="table table-bordered table-hover" data-pagination="true" ref="ym_list"></table>
				</div>
				<!-- 导出设置弹窗 -->
				<div class="export-alert" ref="ym_export_alert">
					<div class="set-export">
						<h3>请选择导出报表需要的显示的字段</h3>
						<ul class="set-area clearfix">
							<li>
								<input type='checkbox' v-model='ym_export_all' @click='ymExportAll'>
								<label>全选</label>
							</li>
							<li v-for="item in ym_export_arr">
								<input type="checkbox" v-model='ym_export_item' :value="item.key">
								<label>{{item.name}}</label>
							</li>
						</ul>
						<h3>请选择导出报表的文件格式</h3>
						<ul class="clearfix">
							<li>
								<input type="radio" v-model='ym_export_type' value="1">
								<label>excel表格</label>
							</li>
							<li>
								<input type="radio" v-model='ym_export_type' value="2">
								<label>pdf文件</label>
							</li>
						</ul>
					</div>
				</div>
			</div>

			<!-- 日营业汇总报表 -->
			<div class="yh-list" v-show="showList2">
				<div class="row">
					<button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backFun">返回</button>
				</div>
				<h1>日营业汇总报表</h1>
				<div class="row">
					<label class="col-md-1 list-label-2">日期:</label>
					<div class="col-md-2 list-date">
						<div ref="yh_date">
							<input type="text" class="form-control laydate-icon" v-model="yh_start_time"> -
							<input type="text" class="form-control laydate-icon" v-model="yh_end_time">
						</div>
					</div>
					<label class="col-md-1 list-label-3">门店:</label>
					<div class="col-md-2 ct-col">
						<select class="form-control" ref="yh_shop"></select>
					</div>
					<label class="col-md-1 list-label-2">总计:</label>
					<div class="list-total">{{yh_amount}}</div>
					<div class="pull-right">
						<button type="button" class="btn btn-flat btn-small btn-orange" @click="yhQuery">查询</button>
						<button type="button" class="btn btn-flat btn-small btn-orange" @click="yhExportSet">导出</button>
					</div>
				</div>
				<div class="table-responsive">
					<table class="table table-bordered table-hover" data-pagination="true" ref="yh_list"></table>
				</div>
				<!-- 导出设置弹窗 -->
				<div class="export-alert" ref="yh_export_alert">
					<div class="set-export">
						<h3>请选择导出报表需要的显示的字段</h3>
						<ul class="set-area clearfix">
							<li>
								<input type='checkbox' v-model='yh_export_all' @click='yhExportAll'>
								<label>全选</label>
							</li>
							<li v-for="item in yh_export_arr">
								<input type="checkbox" v-model='yh_export_item' :value="item.key">
								<label>{{item.name}}</label>
							</li>
						</ul>
						<h3>请选择导出报表的文件格式</h3>
						<ul class="clearfix">
							<li>
								<input type="radio" v-model='yh_export_type' value="1">
								<label>excel表格</label>
							</li>
							<li>
								<input type="radio" v-model='yh_export_type' value="2">
								<label>pdf文件</label>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	export default {
		// name: 'order_manage',
		data() {
			return {
				showTit: true,
				showList1: false,
				showList2: false,

				ym_time: '',
				ym_amount: '',
				ym_columns: [],
				ym_table_total: '',
				ym_export_all: false,
				ym_export_all_c: false,
				ym_export_arr: [],
				ym_export_item: [],
				ym_export_type: 1,

				yh_start_time: '',
				yh_end_time: '',
				yh_amount: '',
				yh_columns: [],
				yh_table_total: '',
				yh_export_all: false,
				yh_export_all_c: false,
				yh_export_arr: [],
				yh_export_item: [],
				yh_export_type: 1,
			}
		},
		computed: {
			
		},
		watch: {
			ym_export_item: {
				handler: function (val, oldVal) {
					if(this.ym_export_item.length >= this.ym_export_arr.length) {
						this.ym_export_all = true;
						this.ym_export_all_c = true;
					} else {
						this.ym_export_all = false;
						this.ym_export_all_c = false;
					}
				},
				deep: true
			},

			yh_export_item: {
				handler: function (val, oldVal) {
					if(this.yh_export_item.length >= this.yh_export_arr.length) {
						this.yh_export_all = true;
						this.yh_export_all_c = true;
					} else {
						this.yh_export_all = false;
						this.yh_export_all_c = false;
					}
				},
				deep: true
			},
		},
		mounted: function() {
			
		},
		methods: {
			titClk: function(num) {
				let _this = this;
				_this.showTit = false;
				_this.showList1 = false;
				_this.showList2 = false;

				if(num == '1') {
					// 日期
					let myDate = new Date(new Date().getTime() - 1 * 24 * 3600 * 1000);
					let year = myDate.getFullYear(),
						month = (myDate.getMonth() + 1) < 10 ? '0' + (myDate.getMonth() + 1) : (myDate.getMonth() + 1),
						day = myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate();
					_this.ym_time = year + '-' + month + '-' + day;
					_this.initDate(num);
					_this.getShop(num);
					_this.showList1 = true;
				} else if(num == '2') {
					// 日期
					let myDate = new Date();
					_this.IntstartTime = new Date(myDate.getTime() - 2 * 24 * 3600 * 1000);
					_this.IntendTime = new Date(myDate.getTime() - 1 * 24 * 3600 * 1000);
					let timStar = new Date(this.IntstartTime),
						year = timStar.getFullYear(),
						month = (timStar.getMonth() + 1) < 10 ? '0' + (timStar.getMonth() + 1) : (timStar.getMonth() + 1),
						day = timStar.getDate() < 10 ? '0' + timStar.getDate() : timStar.getDate();
					let timEnd = new Date(this.IntendTime),
						yearend = timEnd.getFullYear(),
						monthend = (timEnd.getMonth() + 1) < 10 ? '0' + (timEnd.getMonth() + 1) : (timEnd.getMonth() + 1),
						dayend = timEnd.getDate() < 10 ? '0' + timEnd.getDate() : timEnd.getDate();
					_this.yh_start_time = year + '-' + month + '-' + day;
					_this.yh_end_time = yearend + '-' + monthend + '-' + dayend;
					_this.initDate(num);
					_this.getShop(num);
					_this.showList2 = true;
				}
			},
			backFun: function() {
				this.showTit = true;
				this.showList1 = false;
				this.showList2 = false;
			},
			// 日期
			initDate: function(num) {
				let _this = this;

				if(num == '1') {
					$(_this.$refs.ym_date).daterangepicker({
						singleDatePicker: true, // 设置成单日历
						buttonClasses: ['btn btn-default'],
						applyClass: 'btn-small btn-orange',
						cancelClass: 'btn-small btn-gray',
						maxDate: _this.ym_time
					}, function(start, end, label) {
						_this.ym_time = start.format('YYYY-MM-DD');
					});
				} else if(num == '2') {
					$(_this.$refs.yh_date).daterangepicker({
						buttonClasses: ['btn btn-default'],
						applyClass: 'btn-small btn-orange',
						cancelClass: 'btn-small btn-gray',
						startDate: _this.IntstartTime,
						endDate: _this.IntendTime,
					}, function(start, end, label) {
						_this.yh_start_time = start.format('YYYY-MM-DD');
						_this.yh_end_time = end.format('YYYY-MM-DD');
					});
				}
			},
			// 门店
			getShop: function(num) {
				let _this = this;

				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							let arr = [];
							$.each(data.response.result, function(k, v) {
								arr.push({ id: v.id, text: v.name });
							});
							arr.shift();

							if(num == 1) {
								$(_this.$refs.ym_shop).select2({
									data: arr,
									language: "zh-CN",
									width: '100%'
								});
								_this.ymColumns();
								_this.ymInitTable();
							} else if(num == 2) {
								$(_this.$refs.yh_shop).select2({
									data: arr,
									language: "zh-CN",
									width: '100%'
								});
								_this.yhColumns();
								_this.yhInitTable();
							}
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.data.error_msg);
						}
					},
					error: function(err) {
						layer.msg("网络错误");
					}
				});
			},



			/*
			 * 日营业明细报表
			 */
			// 表格标题
			ymColumns: function() {
				let _this = this;
				
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": 1,
							"page_size": 15,
							"date": _this.ym_time,
							"shop_id": $(_this.$refs.ym_shop).val()
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "FalsifyBill/getDetailData",
					crossDomain: true,
					async: false,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							// 标题
							let obj = data.response.result.column_arr;
							_this.ym_columns = [];
							_this.ym_export_arr = [];
							for(var i in obj) {
								_this.ym_columns.push({
									field: i,
									title: obj[i],
									width: '5%',
									valign: "middle"
								});

								// 导出数据
								_this.ym_export_arr.push({
									'key': i,
									"name": obj[i]
								});
							}
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 表格
			ymInitTable: function() {
				let _this = this;
				$(_this.$refs.ym_list).bootstrapTable('destroy');
				$(_this.$refs.ym_list).bootstrapTable({
					pageNumber: 1,
					pageSize: 15,
					pageList: [],
					pagination: true,
					ajax: function(params) {
						_this.ymList(params);
					},
					sidePagination: "server",
					columns: _this.ym_columns
				});
			},
			// 数据
			ymList: function(params) {
				let _this = this,
					pageNumber = 1;
				if(params != "" && params.data.offset != 0) {
					pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": pageNumber,
							"page_size": params.data.limit,
							"date": _this.ym_time,
							"shop_id": $(_this.$refs.ym_shop).val()
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "FalsifyBill/getDetailData",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							if(pageNumber == '1') {
								_this.ym_amount = data.response.result.total_amount;
								_this.ym_table_total = data.response.result.count;
							}
							params.success({
								total: _this.ym_table_total,
								rows: data.response.result.data,
							});
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
							params.success({
								total: 0,
								rows: 0
							});
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 查询
			ymQuery: function() {
				this.ymColumns();
				this.ymInitTable();
			},
			// 获取导出设置
			ymExportSet: function() {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"report_type": "FalsifyBill/exportDetailData"
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "FinanceReport/getExportSet",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							if(data.response.result) {
								_this.ym_export_item = data.response.result.export_fields;
								_this.ym_export_type = data.response.result.export_type;
							} else {
								_this.ym_export_item = [];
								_this.ym_export_arr.forEach(function(item) {
									_this.ym_export_item.push(item.key);
								});
								_this.ym_export_type = 1;
							}
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});

				// 弹窗
				layer.confirm('', {
					skin: 'add_printer_area',
					type: 1,
					btn: ['确定', '取消'], // 按钮
					title: ['导出设置', true],
					area: ['830px', ''], // 宽高
					content: $(_this.$refs.ym_export_alert)
				}, function() {
					_this.ymExportList();
				});
			},
			// 导出字段全选
			ymExportAll: function() {
				let _this = this;
				_this.ym_export_all = _this.ym_export_all_c;
				if(!_this.ym_export_all) { // 实现全选
					_this.ym_export_item = [];
					_this.ym_export_arr.forEach(function(item) {
						_this.ym_export_item.push(item.key);
					});
				} else { // 实现反选
					_this.ym_export_item = [];
				}
			},
			// 导出账单汇总列表
			ymExportList: function() {
				let _this = this;

				if(_this.ym_export_item.length == '0') {
					layer.msg('导出字段不能为空');
					return false;
				}
				let export_fields = JSON.stringify(_this.ym_export_item);
				window.location.href = Vue.ctUrl + "FalsifyBill/exportDetailData?" +
					"date=" + _this.ym_time +
					"&shop_id=" + $(_this.$refs.ym_shop).val() +
					"&export_fields=" + export_fields +
					"&export_type=" + _this.ym_export_type;
				
				layer.msg("导出成功！");
				layer.closeAll();
			},



			/*
			 * 日营业汇总报表
			 */
			// 表格标题
			yhColumns: function() {
				let _this = this;
				
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": 1,
							"page_size": 15,
							"start_time": _this.yh_start_time,
							"end_time": _this.yh_end_time,
							"shop_id": $(_this.$refs.yh_shop).val()
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "FalsifyBill/getSumData",
					crossDomain: true,
					async: false,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							// 标题
							let obj = data.response.result.column_arr;
							_this.yh_columns = [];
							_this.yh_export_arr = [];
							for(var i in obj) {
								_this.yh_columns.push({
									field: i,
									title: obj[i],
									width: '5%',
									valign: "middle"
								});

								// 导出数据
								_this.yh_export_arr.push({
									'key': i,
									"name": obj[i]
								});
							}
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 表格
			yhInitTable: function() {
				let _this = this;
				$(_this.$refs.yh_list).bootstrapTable('destroy');
				$(_this.$refs.yh_list).bootstrapTable({
					pageNumber: 1,
					pageSize: 15,
					pageList: [],
					pagination: true,
					ajax: function(params) {
						_this.yhList(params);
					},
					sidePagination: "server",
					columns: _this.yh_columns
				});
			},
			// 数据
			yhList: function(params) {
				let _this = this,
					pageNumber = 1;
				if(params != "" && params.data.offset != 0) {
					pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": pageNumber,
							"page_size": params.data.limit,
							"start_time": _this.yh_start_time,
							"end_time": _this.yh_end_time,
							"shop_id": $(_this.$refs.yh_shop).val()
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "FalsifyBill/getSumData",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							if(pageNumber == '1') {
								_this.yh_amount = data.response.result.total_amount;
								_this.yh_table_total = data.response.result.count;
							}
							params.success({
								total: _this.yh_table_total,
								rows: data.response.result.data,
							});
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
							params.success({
								total: 0,
								rows: 0
							});
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 查询
			yhQuery: function() {
				this.yhColumns();
				this.yhInitTable();
			},
			// 获取导出设置
			yhExportSet: function() {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"report_type": "FalsifyBill/exportSumData"
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "FinanceReport/getExportSet",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							if(data.response.result) {
								_this.yh_export_item = data.response.result.export_fields;
								_this.yh_export_type = data.response.result.export_type;
							} else {
								_this.yh_export_item = [];
								_this.yh_export_arr.forEach(function(item) {
									_this.yh_export_item.push(item.key);
								});
								_this.yh_export_type = 1;
							}
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});

				// 弹窗
				layer.confirm('', {
					skin: 'add_printer_area',
					type: 1,
					btn: ['确定', '取消'], // 按钮
					title: ['导出设置', true],
					area: ['830px', ''], // 宽高
					content: $(_this.$refs.yh_export_alert)
				}, function() {
					_this.yhExportList();
				});
			},
			// 导出字段全选
			yhExportAll: function() {
				let _this = this;
				_this.yh_export_all = _this.yh_export_all_c;
				if(!_this.yh_export_all) { // 实现全选
					_this.yh_export_item = [];
					_this.yh_export_arr.forEach(function(item) {
						_this.yh_export_item.push(item.key);
					});
				} else { // 实现反选
					_this.yh_export_item = [];
				}
			},
			// 导出账单汇总列表
			yhExportList: function() {
				let _this = this;

				if(_this.yh_export_item.length == '0') {
					layer.msg('导出字段不能为空');
					return false;
				}
				let export_fields = JSON.stringify(_this.yh_export_item);
				window.location.href = Vue.ctUrl + "FalsifyBill/exportSumData?" +
					"start_time=" + _this.yh_start_time +
					"&end_time=" + _this.yh_end_time +
					"&shop_id=" + $(_this.$refs.yh_shop).val() +
					"&export_fields=" + export_fields +
					"&export_type=" + _this.yh_export_type;
				
				layer.msg("导出成功！");
				layer.closeAll();
			},
		}

	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	.actreport-manage-wrap {
		.list-tit {
			span {
				width: 100%;
				border: 1px solid #CCC;
				line-height: 50px;
				font-size: 16px;
				text-align: center;
				cursor: pointer;
				border-radius: 10px;
			}
		}
		.set-export {
			width: 90%;
			margin: 0 auto;
			padding: 0 20px 20px;
			h3 {
				font-size: 16px;
			}
			li {
				float: left;
				width: 20%;
				line-height: 32px;
				input {
					float: left;
					margin: 9px 7px 0 0;
				}
				label {
					float: left;
					width: 80%;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}
			}
		}
		h1 {
			margin: 0 0 50px;
			text-align: center;
		}

		.ym-list, .yh-list {
			.table-responsive {
				.fixed-table-body {
					overflow-x: scroll;
				}
			}
			button {
				margin: 0 0 0 30px;
			}
			.export-alert {
				display: none;
			}
		}
	}
</style>